import { render, staticRenderFns } from "./SolicitudesUsuarioWeb.vue?vue&type=template&id=61c82f9a&scoped=true"
import script from "./SolicitudesUsuarioWeb.vue?vue&type=script&lang=js"
export * from "./SolicitudesUsuarioWeb.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesUsuarioWeb.vue?vue&type=style&index=0&id=61c82f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c82f9a",
  null
  
)

export default component.exports